import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { DocumentDto } from '../models/document-dto';

@Injectable({
  providedIn: 'root'
})
export class DocumentsApiService {
  private readonly httpClient = inject(HttpClient);

  public getPhlebotomyDocuments(): Observable<DocumentDto[]> {
    const url = environment.apiUrl + '/documents/phlebotomy';
    return this.httpClient.get<DocumentDto[]>(url);
  }

  public getForms(): Observable<DocumentDto[]> {
    const url = environment.apiUrl + '/documents/ContactUs.asp';
    return this.httpClient.get<DocumentDto[]>(url);
  }

  public getPrinterDownloads(): Observable<DocumentDto[]> {
    const url = environment.apiUrl + '/documents/PrinterDownloads';
    return this.httpClient.get<DocumentDto[]>(url);
  }
}
